import {get} from 'aws-amplify/api';
import {Command, type GetMethod} from '../../Command';
import type {TeamListResponse} from '../../../dto/team/TeamListResponse';

// Aligned on the shared wire contract (PER-315): the client deserializes the
// `GET /teams` payload into exactly the shape the API serializes.
export class GetTeamCommand extends Command<GetMethod, TeamListResponse[]> {
  constructor() {
    super(get, {
      path: `/teams`,
    });
  }

  async deserialize(output: ReturnType<typeof get>): Promise<TeamListResponse[]> {
    const {body} = await output.response;
    return await (body.json() as unknown as Promise<TeamListResponse[]>);
  }
}
